<div nz-row>
  <div nz-col nzSpan="24" style="margin-bottom: 1rem;" class="no-form">
    <h1>Sospendi identità</h1>
  </div>
</div>
<div class="centered-box-vertical large">
  <span class="textEditIdentity">È possibile sospendere temporaneamente l'identità digitale SPID. Durante il periodo di sospensione, le
    credenziali non permetteranno di accedere ai servizi SPID ma potrai riattivarle attraverso questo portale. A partire
    dalla sospensione avrai 30 giorni di tempo per richiedere la revoca definitiva dell'identità. Se TeamSystem non
    riceverà la documentazione per la revoca definitiva, procederà alla riattivazione automatica dell'identità
    digitale.</span>
  <nz-spin nzTip="Invio richiesta..." [nzSpinning]="isSpinning">
    <form autocomplete="off" nz-form class="custom-form" [formGroup]="validateForm">
      <div nz-row nzJustify="start" [nzGutter]="20" nzAlign="top">
        <div nz-col nzSpan="24" class="no-form">
          <nz-form-item class="login">
            <nz-form-control [nzErrorTip]="getValidationErrorMessage(validateForm.controls.emergencyCode.errors)">
              <nz-input-group nzPrefixIcon="lock" class="login" [nzSuffix]="emergencyCodeTemplate">
                <input [type]="emergencyCodeVisible ? 'text' : 'password'" nz-input name="emergencyCode"
                  placeholder="Codice di emergenza" formControlName="emergencyCode" />
              </nz-input-group>
              <ng-template #emergencyCodeTemplate>
                <i nz-icon [nzType]="emergencyCodeVisible ? 'eye-invisible' : 'eye'"
                  (click)="emergencyCodeVisible = !emergencyCodeVisible"></i>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-row nzJustify="start" [nzGutter]="20" nzAlign="top">
        <div nz-col nzSpan="24" class="no-form">
          <app-resend-otp
            [disabled]="!validateForm.controls.emergencyCode.valid || timerService.otpSended"
            [validateForm]="validateForm"
            [errorTip]="getValidationErrorMessage(validateForm.controls.otpCode.errors)"
            (isSpinning)="activateSpin($event)"
          ></app-resend-otp>
        </div>
      </div>
      <div nz-row class="confirmIdentity" nzAlign="middle" nzJustify="space-between">
        <div nz-col [nzSpan]="16">
          <a (click)='onErcLost()'>Hai dimenticato il codice di emergenza?</a>
        </div>
        <div nz-col [nzSpan]="8">
          <button class="submit" nz-button nzType="primary" (click)="submitForm()"
            [disabled]="!validateForm.valid">CONFERMA</button>
        </div>
      </div>
    </form>
  </nz-spin>
</div>

<app-erc-lost-modal-component [events]="onErcLostEventSubject.asObservable()"></app-erc-lost-modal-component>
